import { Box, Button } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import { useNavigate } from "react-router-dom";
import DynamicPageLayout from "../common/DynamicPageLayout";
import { useReportDetails } from "./useReportsDetails";

const ReportsDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const { reportsContentJson } = useReportDetails();

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate("/reports")}
        >
          Back
        </Button>
      </Box>

      <DynamicPageLayout pageContentJson={reportsContentJson} data={{}} />
    </>
  );
};

export default ReportsDetails;
